export const SUP_WHATMAN_METHODS_AND_STANDARDS_SEARCH_LOADER = {
  desktop: `
<div class="cui">
  <div class="cui-grid">
    <div class="cui-container" style="line-height: 0;">

      <!-- Back link skeleton -->
      <div class="cui-skeleton-paragraph__content -spacing--top-64 -spacing--bottom-40" style="width: 20%;">
        <div class="cui-skeleton__item" style="height: 19px"></div>
      </div>

      <!-- Title Skeleton -->
      <div>
        <div class="cui-skeleton-heading__content -spacing--bottom-8" style="width: 60%;">
          <div class="cui-skeleton__item" style="height: 40px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 80%;">
        <div class="cui-skeleton__item" style="height: 27.891px"></div>
      </div>

      <!-- Filters Skeleton -->
      <div>
        <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 60%;">
          <div class="cui-skeleton__item" style="height: 48px"></div>
        </div>
        <div class="cui-skeleton-paragraph__content -spacing--bottom-40" style="width: 50%">
          <div class="cui-skeleton__item" style="height: 48px"></div>
        </div>
      </div>

      <!-- Table -->
      <div class="cui-skeleton-heading__content  -spacing--bottom-40" style="width: 100%">
        <div class="cui-skeleton__item" style="height: 1024px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 18px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 40px;"></div>
      </div>

      <!-- Additional spacing -->
      <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 120px;"></div>

    </div>
  </div>
</div>
`
};
